import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UpdateConfirmationDialog } from '@core/models/shared/update-confirmation-dialog.model';
import { position, onDragEnded } from '@shared/helpers/dialog-drag-constraints';

export enum UpdateConfirmationDialogAction {
  No = -1,
  Yes = -2
}

@Component({
    selector: 'app-update-confirmation',
    templateUrl: './update-confirmation.component.html',
    styleUrls: ['./update-confirmation.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class UpdateConfirmationComponent {
  static readonly componentName = 'UpdateConfirmationComponent';
  
  public position = position;
  public onDragEnded = onDragEnded;

  constructor(@Inject(MAT_DIALOG_DATA)
    public data: { 
      sysText: any,
      updateConfirmationDialog: UpdateConfirmationDialog
    },
    private dialogRef: MatDialogRef<UpdateConfirmationComponent>
    ) { }

  public onAction(action: UpdateConfirmationDialogAction): void {
    this.dialogRef.close(action);
  }
}
